import React, { useState } from 'react';
import Tabs from './tabs';
import CreateKybKycLogs from './CreateKybKycLogs';
import { TAB_OPTIONS } from './tabOptions';
import OrgConfirmationLogs from './OrgConfirmationLogs';
import DefaultPaymentMethodSetLogs from './DefaultPaymentMethodSetLogs';
import PayoutFrequencySetLogs from './PayoutFrequencySetLogs';

export default function Logs(logsProps: {
  token: string;
  orgId: string;
}): React.JSX.Element {
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

  const selectedTab =
    selectedTabIndex !== undefined ? TAB_OPTIONS[selectedTabIndex] : undefined;
  let logComponent: React.JSX.Element | undefined = undefined;
  if (selectedTab?.name === 'CreateKybKyc') {
    logComponent = <CreateKybKycLogs {...logsProps} />;
  } else if (selectedTab?.name === 'OrgConfirmation') {
    logComponent = <OrgConfirmationLogs {...logsProps} />;
  } else if (selectedTab?.name === 'DefaultPaymentMethodSet') {
    logComponent = <DefaultPaymentMethodSetLogs {...logsProps} />;
  } else if (selectedTab?.name === 'PayoutFrequencySet') {
    logComponent = <PayoutFrequencySetLogs {...logsProps} />;
  } else if (selectedTab !== undefined) {
    throw new Error('Audit Log Type not implemented');
  }

  return (
    <div>
      <Tabs onTabSelected={setSelectedTabIndex} />
      {logComponent}
    </div>
  );
}
